import request from '../../utils/request'
import config from '../../../config/config'
const baseURL = config.baseUrl;
//  管理员登录
export function login (data) {
  
  return request({
    url: baseURL + 'users/adminLogin',
    method: 'post',
    data: data
  })
}

//  管理员登录
export function userLogin (data) {
  
  return request({
    url: baseURL + 'users/userLogin',
    method: 'post',
    data: data
  })
}

//  用户分页查询
export function userList (data) {
  return request({
    url: baseURL + 'users/list',
    method: 'post',
    data: data
  })
}
//  用户分页查询
export function userUpdate (data) {
  return request({
    url: baseURL + 'users/update',
    method: 'post',
    data: data
  })
}
//  用户分页查询
export function introUpdate (data) {
  return request({
    url: baseURL + 'intro/update',
    method: 'post',
    data: data
  })
}
//  用户分页查询
export function introList(data) {
  return request({
    url: baseURL + 'intro/list',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/user/user.js